<template>
    <div class="wrap">
        <div class="publicTitle">
            当前位置：<span>{{ titleOne.first }} &lt; </span
            ><span>{{ titleOne.second }}</span>
        </div>
        <div class="zixun-box flex-row">
            <div
                v-for="(item, index) in arrOne"
                :key="index"
                class="zixun-item"
            >
                <div
                    @click="goDetails(item)"
                    class="zixun-item-img bg scale-box"
                >
                    <img :src="item.image" :alt="item.title" />
                </div>
                <div class="zixun-item-content">
                    <h2>{{ item.title }}</h2>
                    <p class="tips">
                        <span>{{ item.creaTime.time | dateFormat }}</span>
                        <span>浏览次数：{{ item.popularity }}</span>
                    </p>
                    <p class="intro">
                        {{
                            item.introduction && item.introduction.length > 80
                                ? item.introduction.substring(0, 80) + "..."
                                : item.introduction
                        }}
                        <span @click="goDetails(item)" class="view-more"
                            >&lt;查看更多&gt;</span
                        >
                    </p>
                </div>
            </div>
        </div>
        <pagebreak
            :totalPage="pageData.totalPage"
            @changePage="getListData"
        ></pagebreak>
    </div>
</template>

<script>
export default {
    name: "articalList",
    data() {
        return {
            arrOne: [],
            pageData: {
                current: 1,
                totalPage: 1
            },
            navigationId: null,
            titleOne: {
                first: "",
                second: ""
            }
        };
    },
    created() {
        this.navigationId = this.$route.query.id;
        this.titleOne.first = this.$route.query.t1;
        this.titleOne.second = this.$route.query.t2;
        this.getListData();
    },
    methods: {
        goDetails(item) {
            this.$router.push({
                name: "artDetail",
                query: {
                    id: item.id,
                    t1: this.titleOne.first,
                    t2: this.titleOne.second ? this.titleOne.second : ""
                }
            });
        },
        getListData(page = 1) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    navigationId: this.navigationId,
                    current: page
                },
                success: res => {
                    if (res.code == 200) {
                        this.arrOne = res.message.records;
                        this.pageData.totalPage = Math.ceil(
                            res.message.total / res.message.size
                        );
                    }
                },
                error: res => {
                    console.log(res);
                }
            });
        }
    }
};
</script>

<style scoped="scoped" lang="scss">
.wrap {
    width: 1000px;
    margin: 0 auto;
}
.publicTitle {
    margin: 5px 0;
    color: #999;
    font-size: 16px;
}
// 资讯
.zixun-box {
    margin-top: 20px;
    min-height: 500px;
    align-items: flex-start;
    align-content: flex-start;
    .zixun-item {
        margin-right: 35px;
        margin-bottom: 20px;
        font-size: 14px;
        .zixun-item-img {
            vertical-align: top;
            display: inline-block;
            height: 164px;
            width: 242px;
            border: 1px solid #ddd;
            box-sizing: border-box;
            overflow: hidden;
            img {
                width: 100%;
                min-height: 100%;
            }
        }
        .zixun-item-content {
            display: inline-block;
            vertical-align: top;
            margin-left: 6px;
            width: 230px;
            height: 164px;
            h2 {
                padding: 5px 0;
                font-size: 16px;
                line-height: 20px;
                font-weight: bold;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .tips {
                line-height: 20px;
                color: #666;
                span:nth-child(1) {
                    margin-right: 20px;
                }
            }
            .intro {
                margin-top: 5px;
                line-height: 18px;
                height: 90px;
                overflow: hidden;
                position: relative;
                word-break: break-all;
            }
            .view-more {
                display: inline-block;
                height: 18px;
                line-height: 18px;
                color: #3366cc;
                background-color: #fff;
                cursor: pointer;
            }
        }
    }
    .zixun-item:nth-child(2n) {
        margin-right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/public/articalList.vue